import {Result} from 'antd'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import PermissionContext from 'modules/permissions/PermissionContext'
import React from 'react'
import {branch, compose, fromRenderProps,} from 'recompose'

// Nguồn duy nhất cho việc "có được xem/dùng menu này không" ở client - mọi nơi cần
// check permission (sidebar, page-level guard...) đều gọi qua đây, không tự viết lại.
// - required_permissions rỗng -> luôn cho phép (chức năng chung, vd dashboard).
// - required_permissions không rỗng -> phải có ít nhất 1 quyền được cấp (OR), kể cả khi
//   permissions chưa load xong (rỗng) -> mặc định KHÔNG cho phép (fail-closed), tránh
//   nhấp nháy "đang bật" rồi tắt lại khi data load xong mới biết là không có quyền.
export const hasPermissions = (
    permissions = [],
    required_permissions = []
) =>
    _.isEmpty(required_permissions)
        ? true
        : !!_.find(
        required_permissions,
        (key) => !!permissions[key]
        )

export const invalidPermissions =
    (permissions) =>
        ({required_permissions}) =>
            !hasPermissions(
                permissions,
                required_permissions
            )

export const createCheckPermissions = (
    checkPermissions = [],
    FallBackComponent = () => (
        <Translate>
            {(t) => (
                <Result
                    status="403"
                    title={t('permission denied')}
                    subTitle={t('permission denied description')}
                />
            )}
        </Translate>
    )
) =>
    compose(
        fromRenderProps(
            PermissionContext.Consumer,
            (permissions) => ({
                denied: !hasPermissions(permissions, checkPermissions),
            })
        ),
        branch(
            ({denied}) => denied,
            () => FallBackComponent
        )
    )
